module.exports = __webpack_public_path__ + "static/media/Logo.fa2256d7.svg";